import { selectMe } from "../../ducks/auth/selectors";
import { useAppDispatch, useAppSelector } from "../../redux-store";
import {
  selectMarkNotificationAsSeenInProgress,
  selectNotificationInView,
} from "../../ducks/app/notifications/selectors";
import "./InAppNotifications.scss";
import {
  loadNotifications,
  markNotificationAsSeen,
} from "../../ducks/app/notifications";
import "./InAppNotifications.scss";
import { LoadingButton } from "@mui/lab";
import { useEffect, useRef } from "react";
import useFeature from "../../hooks/useFeature";
import { useTranslation } from "react-i18next";
import InAppTextNotification from "./notification-types/InAppTextNotification";
import InAppRouteUpdatedNotification from "./notification-types/InAppRouteUpdatedNotification";
import Dialog from "@mui/material/Dialog";
import { DateTime } from "luxon";
import InAppStopDocumentsAddedNotification from "./notification-types/InAppStopDocumentsAddedNotification";

const InAppNotifications = () => {
  const { t } = useTranslation("notifications");
  const me = useAppSelector(selectMe);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const latestReceivedNotification = useAppSelector(selectNotificationInView);
  const markSeenInProgress = useAppSelector(
    selectMarkNotificationAsSeenInProgress
  );
  const driverInAppNotificationsEnabled = useFeature(
    "driver-in-app-notifications"
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (driverInAppNotificationsEnabled) {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          if (me) {
            dispatch(loadNotifications());
          }
        }, 10000);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [dispatch, driverInAppNotificationsEnabled, intervalRef, me]);

  if (!driverInAppNotificationsEnabled || !me || !latestReceivedNotification) {
    return null;
  }

  const onDismissNotificationClick = () => {
    dispatch(markNotificationAsSeen(latestReceivedNotification.id));
  };

  const notificationDateTime = DateTime.fromISO(
    latestReceivedNotification.timestamp,
    { zone: "utc" }
  )
    .toLocal()
    .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);

  return (
    <Dialog open onClose={onDismissNotificationClick}>
      <div className="in-app-notifications">
        <div
          className="mb-3"
          style={{ color: "var(--gray-800)", fontSize: 14 }}
        >
          {notificationDateTime.toFormat("HH:mm dd.MM.yyyy")}
        </div>
        <div>
          {latestReceivedNotification.type === "TEXT" && (
            <InAppTextNotification notification={latestReceivedNotification} />
          )}
          {latestReceivedNotification.type === "ROUTE_UPDATED" && (
            <InAppRouteUpdatedNotification
              notification={latestReceivedNotification}
            />
          )}
          {latestReceivedNotification.type === "STOP_DOCUMENTS_ADDED" && (
            <InAppStopDocumentsAddedNotification
              notification={latestReceivedNotification}
            />
          )}
        </div>
        <br />
        <LoadingButton
          loading={markSeenInProgress}
          fullWidth
          onClick={onDismissNotificationClick}
          variant="contained"
        >
          {t("dismiss")}
        </LoadingButton>
      </div>
    </Dialog>
  );
};

export default InAppNotifications;
